import {
  BulkTypeDeliveryPeriod,
  DeliveryPeriodType,
  UiState,
} from '../../models';
import { mapDeliveryTypeToOrderType } from '../../shared/shared';

export const updateUiDeliveryState = (
  state: UiState,
  deliveryPeriodType: DeliveryPeriodType,
  date: string | BulkTypeDeliveryPeriod | null = null,
) => ({
  ...state,
  preSelectedOrderType: mapDeliveryTypeToOrderType(deliveryPeriodType),
  selectedOrderType: mapDeliveryTypeToOrderType(deliveryPeriodType),
  preSelectedDeliveryPeriodType: deliveryPeriodType,
  preSelectedDeliveryPeriod: date,
});
